export const INTRO_TO_CODING = 'Intro to Coding';
export const INTRO_TO_SCRATCH = 'Intro to Scratch';
export const SCRATCH = 'Scratch';
export const WOOF = 'Woof';
export const WEB = 'Web';
export const STUDENT = 'Student';
// export const OFFICIAL = 'Official';


